import React from 'react'
import {Modal} from "react-bootstrap"


function ModalPolityka(props) {
    return (
      <Modal
        show={props.show}
        onHide={() => props.handleclose()}
        centered
        size="lg"
      >
        <div className="p-xl-4 p-xxl-5">
          <Modal.Header closeButton>
            <Modal.Title>Zastrzeżenia prawne</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Wszelkie prawa do całej zawartości serwisu internetowego ORLEN
              S.A, są zastrzeżone. Użytkownik ma prawo do pobrania oraz
              drukowania całych stron lub fragmentów serwisu internetowego               ORLEN S.A, pod warunkiem nienaruszania praw autorskich oraz praw z
              rejestracji znaków towarowych należących do ORLEN. Żadna część
              serwisu nie może być w celach komercyjnych kopiowana w całości lub
              części, transmitowana elektronicznie lub w inny sposób,
              modyfikowana, linkowana lub wykorzystana bez uprzedniej pisemnej
              zgody ORLEN S.A.
            </p>
            <p>
              ORLEN S.A. na bieżąco aktualizuje informacje zawarte w
              serwisie, jednak nie ponosi żadnej odpowiedzialności za
              dokładność, aktualność oraz kompletność informacji przedstawionych
              na stronach serwisu. Jednocześnie ORLEN zastrzega sobie prawo
              do wprowadzania zmian w części lub całości serwisu bez
              uprzedzenia. Ryzyko związane z użytkowaniem i wykorzystaniem
              informacji przedstawionych w serwisie ponosi sam użytkownik.               ORLEN S.A. nie ponosi żadnej odpowiedzialności z tytułu
              wyrządzonych szkód będących rezultatem korzystania z serwisu               ORLEN S.A.
            </p>
            <p>
              Polski Koncern Naftowy ORLEN Spółka Akcyjna z siedzibą w Płocku,
              ul. Chemików 7, 09-411 Płock wpisana do rejestru przedsiębiorców
              prowadzonego przez Sąd Rejonowy dla Łodzi-Śródmieścia w Łodzi XX
              Wydział Gospodarczy Krajowego Rejestru Sądowego pod numerem:
              0000028860 NIP: 774-00-01-454, BDO 000007103, kapitał zakładowy /
              kapitał wpłacony: 534.636.326,25 zł
            </p>
          </Modal.Body>
        </div>
      </Modal>
    )
}

export default ModalPolityka
